import { useMutation } from '@redwoodjs/web';

import { showErrorToast } from 'src/components/Toasts/toast';
import { REGENERATE_PRESIGNED_URL } from 'src/graphql/mutations/generateAwsURL.mutation';

const useGeneratePresignedUrl = () => {
    const [generateAWSUrl, { loading }] = useMutation(REGENERATE_PRESIGNED_URL, {
        onError: (err) => {
            showErrorToast(err.message);
        },
    });

    const validateAwsURL = async (url: string): Promise<string | undefined> => {
        if (!url) return undefined;

        const requiresPresignedUrl = !url.includes('prod-bucket');
        if (!requiresPresignedUrl) return url;

        try {
            const { data } = await generateAWSUrl({ variables: { url } });
            return data?.regenerateSecureAWSUrl ?? url;
        } catch {
            showErrorToast('Failed to generate a presigned URL.');
            return url;
        }
    };

    return { validateAwsURL, loading };
};

export default useGeneratePresignedUrl;
